var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticStyle:{"white-space":"normal"}},[_c('swiper',{ref:"mySwiper2",staticClass:"mySwiper2",attrs:{"options":_vm.swiperOption2}},_vm._l((_vm.swiperLists),function(item,index){return _c('swiper-slide',{key:index,attrs:{"width":"100%"}},[_c('ComplateSwiper',{attrs:{"swiperItem":item}})],1)}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }